import React, { useEffect, useState } from 'react';

import AddIcon from '@mui/icons-material/AddCircle';
import AuthService from '../../shared/services/AuthService';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CourseCatalogDialog from './CourseCatalogDialog';
import CourseListPanel from './CourseListPanel';
import { CourseProgressLegend } from './CourseProgressLegend';
import Grid from '@mui/material/Unstable_Grid2';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import Typography from '@mui/material/Typography';
import UserProfilePanel from './UserProfilePanel';
import { isEmpty } from 'lodash';
import usePathways from '../hooks/usePathways';
import usePublicGroups from '../../group/hooks/usePublicGroups';

const UserDashboard = () => {
  const userkey = AuthService.Userkey;
  const [showCourseCatalog, setShowCourseCatalog] = useState(false);
  const [allowAutoCatalog, setAllowAutoCatalog] = useState(true);
  const { getPathways, loading, error, pathways } = usePathways();
  const { loading: loadingPublicGroups, publicGroups } = usePublicGroups();

  useEffect(() => getPathways(userkey), []);

  useEffect(() => {
    if (
      allowAutoCatalog &&
      !loading &&
      !loadingPublicGroups &&
      !isEmpty(publicGroups) &&
      isEmpty(pathways)
    ) {
      // Automatically show course catalog on empty dashboard.
      const timer = setTimeout(() => {
        setShowCourseCatalog(true);
        setAllowAutoCatalog(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [allowAutoCatalog, loading, pathways, loadingPublicGroups, publicGroups]);

  const coursesAvailable = !isEmpty(publicGroups);

  const showCourseCatalogDialog = () => {
    setShowCourseCatalog(true);
  };

  const handleCourseCatalogClose = () => {
    setShowCourseCatalog(false);
    getPathways(userkey);
  };

  return (
    <>
      <Box marginBottom={2} marginLeft={1} marginRight={1}>
        <UserProfilePanel />
      </Box>
      <Box m={1}>
        <Grid container justifyContent={'space-between'}>
          <Grid>
            <Typography variant="h6">My Courses</Typography>
          </Grid>
          {coursesAvailable && (
            <Grid>
              <Tooltip title="Enroll in additional courses">
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={showCourseCatalogDialog}
                >
                  Course
                </Button>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Box>
      <Box m={1}>
        <Grid container direction="column" spacing={4} alignItems="center">
          <Grid>
            <CourseListPanel
              pathwaysLoading={loading}
              pathwaysError={!!error}
              pathways={pathways}
            />
          </Grid>
          <Grid>
            <CourseProgressLegend />
          </Grid>
        </Grid>
      </Box>
      {showCourseCatalog && (
        <CourseCatalogDialog onClose={handleCourseCatalogClose} />
      )}
    </>
  );
};

export default UserDashboard;
